import { Components, Theme } from '@mui/material/styles';

import { BlackHeadings, HoverNonBorderBackground } from 'src/theme/colors';

const MuiIconButton: Components<Theme>['MuiIconButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: 'currentColor',
      padding: '12px',
      '&:hover': {
        backgroundColor: 'transparent',
        color: 'currentColor',
      },
      borderRadius: theme.shape.borderRadius,
    }),
    colorPrimary: ({ theme }) => ({
      color: theme.palette.primary.contrastText,
      '&:hover': {
        color: theme.palette.primary.contrastText,
      },
    }),
    colorSecondary: {
      color: BlackHeadings,
      '&:hover': {
        backgroundColor: HoverNonBorderBackground,
      },
    },
    sizeSmall: {
      padding: '4px',
      fontSize: 'inherit',
    },
  },
};

export default MuiIconButton;
